import React from 'react';
import { XCircle, CheckCircle } from 'lucide-react';
export function BenefitsSection() {
  const scrollToPurchase = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-9">
      <div className="max-w-5xl mx-auto" data-id="element-10">
        <div className="text-center mb-16" data-id="element-11">
          <h2 className="text-3xl sm:text-4xl font-serif font-bold text-brand-purple mb-4" data-id="element-12">
            ¿Te sentís identificada con alguna de estas situaciones?
          </h2>
          <p className="text-lg text-gray-600" data-id="element-13">
            Manejar una clínica de uñas no debería ser un dolor de cabeza
            constante.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12" data-id="element-14">
          {/* Pain Points */}
          <div className="bg-red-50 rounded-2xl p-8 border border-red-100" data-id="element-15">
            <h3 className="text-xl font-bold text-red-800 mb-6 flex items-center" data-id="element-16">
              <XCircle className="w-6 h-6 mr-2" data-id="element-17" />
              La vieja forma (El Caos)
            </h3>
            <ul className="space-y-4" data-id="element-18">
              {['Turnos superpuestos y clientas enojadas esperando.', 'No sabés exactamente cuánto ganás ni cuánto gastás a fin de mes.', 'Fichas de clientas perdidas en cuadernos desordenados.', 'Insumos que se vencen o se acaban sin que te des cuenta.', 'Trabajás 12 horas por día pero no ves la ganancia real.'].map((item, i) => <li key={i} className="flex items-start" data-id="element-19">
                  <span className="text-red-500 mr-3 mt-1" data-id="element-20">✗</span>
                  <span className="text-gray-700" data-id="element-21">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Benefits */}
          <div className="bg-brand-cream rounded-2xl p-8 border border-brand-roseLight shadow-lg relative transform md:-translate-y-4" data-id="element-22">
            <div className="absolute -top-4 right-8 bg-brand-gold text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-23">
              Tu nueva realidad
            </div>
            <h3 className="text-xl font-bold text-brand-purple mb-6 flex items-center" data-id="element-24">
              <CheckCircle className="w-6 h-6 mr-2 text-brand-roseGold" data-id="element-25" />
              Con el Sistema Premium
            </h3>
            <ul className="space-y-4" data-id="element-26">
              {['Agenda optimizada: cero huecos, cero superposiciones.', 'Control financiero total: sabés exactamente tu rentabilidad.', 'Historial clínico digitalizado y protocolos de esterilización al día.', 'Control de inventario inteligente para no desperdiciar productos.', 'Estrategias para atraer y retener clientas VIP que pagan más.'].map((item, i) => <li key={i} className="flex items-start" data-id="element-27">
                  <CheckCircle className="w-5 h-5 text-brand-roseGold mr-3 mt-0.5 flex-shrink-0" data-id="element-28" />
                  <span className="text-gray-800 font-medium" data-id="element-29">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-16 text-center" data-id="element-30">
          <button onClick={scrollToPurchase} className="px-8 py-4 bg-brand-roseGold hover:bg-brand-purple text-white rounded-lg font-bold text-lg transition-colors shadow-md" data-id="element-31">
            SÍ, NECESITO ESTE NIVEL DE ORGANIZACIÓN
          </button>
        </div>
      </div>
    </section>;
}